import CardPm from "components/CardPm";
import Layout from "Layout";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { getPemerintahan } from "services/apiRoutes";
import cx from "classnames";
import HorizontalCard from "components/HorizontalCard";
import ImGov from 'assets/images/ImGov.jpg'
import { useParams } from "react-router-dom";

export default function Pemerintahan() {
  const {slug} = useParams()
  const [pemerintahan, setPemerintahan] = useState();

  const lineClasses = cx({
    "w-[1px] h-[90%] bg-primary border overflow-hidden my-4 border-primary rounded-full absolute right-[50%] -z-[1]":
      pemerintahan?.length !== 0 ? true : "hidden",
  });

  const pemerintahanAPI = useCallback(async () => {
    const res = await getPemerintahan(slug);
    if (res.error) {
      return res.message;
    } else {
      const { data } = res.data;
      setPemerintahan(data);
    }
  }, [slug]);

  useEffect(() => {
    pemerintahanAPI();
  }, [pemerintahanAPI]);
  return (
    <Layout>
      <div className="px-5 py-32 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Pemerintahan
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Pemerintahan"
            img={ImGov}
          />
        </div>
        <div className="relative rounded-full space-y-14 wrapperCardPm">
          <div className={lineClasses} />
          {pemerintahan
            ? pemerintahan?.map((item, index) => (
                <CardPm
                  key={index}
                  name={item?.perangkat_desa_obj?.nama}
                  img={item?.perangkat_desa_obj?.url_gambar}
                  post={`${item?.tgl_mulai?.substring(
                    0,
                    4
                  )} - ${item?.tgl_akhir?.substring(0, 4)}`}
                  desc={item?.deskripsi}
                />
              ))
            : null}
        </div>
      </div>
    </Layout>
  );
}
